<template>
  <div class="main-content">
    <div class="region region-content">
      <section class="block">
        <div class="block__content">
          <h1>Page not found</h1>
        </div>
      </section>
      <section class="block">
        <div class="block__content">
          The requested page could not be found.
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  beforeCreate () {
    this.$parent.notFound = true
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/NotFound.vue